import { render, staticRenderFns } from "./ClublinkHeader.vue?vue&type=template&id=61441e8b&"
import script from "./ClublinkHeader.vue?vue&type=script&lang=js&"
export * from "./ClublinkHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports